var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[(_vm.titleStatus)?_c('page-title',{attrs:{"title":_vm.$t('clientTransactions.items')}}):_vm._e(),_c('main-table',{attrs:{"fields":_vm.fields,"list_url":'admin/user-transaction',"reloadData":_vm.reloadData,"params":_vm.filter,"createStatus":false,"excelFields":_vm.excelFields,"excelName":"clientTransactions"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }